import { Box, Modal } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { Account } from 'types';

import { getActiveBillingBlocks } from '../../helpers/getActiveBillingBlocks';

interface BillingBlockersModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  account: Account | null;
}

export function BillingBlockersModal({ isOpen, onDismiss, account }: BillingBlockersModalProps) {
  const activeBillingBlocks = useMemo(() => {
    return getActiveBillingBlocks(account?.billingBlocks);
  }, [account?.billingBlocks]);

  return (
    <Modal ariaLabelledBy="billingBlocksModal" isOpen={isOpen} onDismiss={onDismiss} maxWidth="600px">
      <Modal.Header
        id="billingBlocksModal"
        title={`Active Billing Blockers (${activeBillingBlocks.length})`}
        onDismiss={onDismiss}
      />
      <Modal.Body childGap="lg" background="secondary">
        {activeBillingBlocks.map((billingBlock: any, index: number) => (
          <Box key={index}>
            <Box childGap="md">
              <Box>
                <Box color="grey-500" fontSize="md" fontWeight="bold" margin="0 0 xs 0">
                  Billing Block {index + 1}:
                </Box>
                <Box fontSize="sm" margin="0 0 xs 0">
                  {billingBlock.reason}
                </Box>
                {billingBlock.notes && (
                  <Box>
                    <Box color="grey-500" fontSize="md" fontWeight="bold" margin="xs 0 2xs 0">
                      Notes:
                    </Box>
                    <Box color="grey-700" fontSize="sm">
                      {billingBlock.notes}
                    </Box>
                  </Box>
                )}
              </Box>

              <Box display="flex" gap="lg" fontSize="sm">
                <Box>
                  <Box fontWeight="bold" color="grey-500" fontSize="md" margin="0 0 2xs 0">
                    Applied By:
                  </Box>
                  <Box color="grey-800">{billingBlock.appliedByEmail || billingBlock.appliedBy || 'system'}</Box>
                </Box>
                <Box>
                  <Box fontWeight="bold" color="grey-500" fontSize="md" margin="0 0 2xs 0">
                    Applied Date:
                  </Box>
                  <Box color="grey-800">
                    {billingBlock.appliedDate
                      ? DateTime.fromISO(billingBlock.appliedDate).toFormat('MMM dd, yyyy')
                      : '---'}
                  </Box>
                </Box>
                {billingBlock.expiresAt && (
                  <Box>
                    <Box fontWeight="bold" color="grey-500" fontSize="md" margin="0 0 2xs 0">
                      Expires:
                    </Box>
                    <Box color="grey-800">{DateTime.fromISO(billingBlock.expiresAt).toFormat('MMM dd, yyyy')}</Box>
                  </Box>
                )}
              </Box>
            </Box>
            {index < activeBillingBlocks.length - 1 && <Box height="1px" background="grey-200" margin="lg 0" />}
          </Box>
        ))}
      </Modal.Body>
    </Modal>
  );
}
